// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c1590e661d99dc0a7c8a32c1e794ccaa8052b44e.chunk.js";
};